import { useState, useEffect } from 'react'
import type { Product } from '../types'

interface QuantityPickerProps {
  product: Product
  onAdd: (quantity: number) => void
  onCancel: () => void
}

const MIN = 1
const MAX = 99

export function QuantityPicker({ product, onAdd, onCancel }: QuantityPickerProps) {
  const [qty, setQty] = useState(1)

  useEffect(() => {
    setQty(1)
  }, [product.id])

  const handleAdd = () => {
    onAdd(qty)
  }

  const subtotal = product.price * qty

  return (
    <div className="quantity-picker-overlay" role="dialog" aria-labelledby="quantity-picker-title" aria-modal="true">
      <div className="quantity-picker">
        <h2 id="quantity-picker-title" className="quantity-picker-title">
          <span className="quantity-picker-emoji" aria-hidden>{product.imagePath}</span>
          {product.name}
        </h2>
        <p className="quantity-picker-price">${product.price.toFixed(2)} each</p>
        <div className="quantity-picker-controls">
          <button
            type="button"
            className="quantity-picker-btn"
            onClick={() => setQty((n) => Math.max(MIN, n - 1))}
            aria-label="Decrease quantity"
          >
            −
          </button>
          <span className="quantity-picker-value" aria-live="polite">{qty}</span>
          <button
            type="button"
            className="quantity-picker-btn"
            onClick={() => setQty((n) => Math.min(MAX, n + 1))}
            aria-label="Increase quantity"
          >
            +
          </button>
        </div>
        <p className="quantity-picker-subtotal">Total: ${subtotal.toFixed(2)}</p>
        <div className="quantity-picker-actions">
          <button type="button" className="btn-large btn-secondary" onClick={onCancel}>
            Cancel
          </button>
          <button type="button" className="btn-large btn-primary" onClick={handleAdd}>
            Add to cart
          </button>
        </div>
      </div>
    </div>
  )
}
